module.exports = __webpack_public_path__ + "static/img/hetong_yixuan.5417fc14.svg";